/**
 * ReplaceConfirm — 420px. "Switch the active route?" when a product:dataType
 * already has an owner. z70.
 */
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { colors, fontFamily, fontSize, fontWeight, radii } from '../theme';
import { Button, Modal } from '../components';
import { Swap } from '../icons';
import { useBridge } from '../store/bridgeStore';
import { allInts, nameOf } from '../domain/catalog';

export default function ReplaceConfirm() {
  const { state, actions } = useBridge();
  if (!state.replace) return null;
  const ints = allInts(state.adapters, state.metaOverrides);
  const r = state.replace;
  const fromName = nameOf(r.fromId, ints);
  const toName = nameOf(r.toId, ints);

  return (
    <Modal width={420} zIndex={70}>
      <View style={styles.body}>
        <View style={styles.iconBox}><Swap size={20} color={colors.warn} /></View>
        <Text style={styles.title}>Switch the active route?</Text>
        <Text style={styles.text}>
          <Text style={styles.bold}>{r.dataType}</Text> for <Text style={styles.bold}>{r.product}</Text> is currently handled by{' '}
          <Text style={styles.bold}>{fromName}</Text>. Switch to <Text style={styles.bold}>{toName}</Text>? Only one can be active at a time.
        </Text>
      </View>
      <View style={styles.footer}>
        <Button label={'Keep ' + fromName} variant="ghost" onPress={actions.cancelReplace} />
        <Button label={'Switch to ' + toName} onPress={actions.confirmReplace} />
      </View>
    </Modal>
  );
}

const styles = StyleSheet.create({
  body: { padding: 22, paddingBottom: 18 },
  iconBox: { width: 40, height: 40, borderRadius: 10, backgroundColor: colors.warnSoft, alignItems: 'center', justifyContent: 'center', marginBottom: 14 },
  title: { fontFamily: fontFamily.sans, fontWeight: fontWeight.semibold, fontSize: fontSize.xl, color: colors.ink, marginBottom: 8 },
  text: { fontFamily: fontFamily.sans, color: colors.ink2, fontSize: fontSize.md, lineHeight: 21 },
  bold: { color: colors.ink, fontWeight: fontWeight.semibold },
  footer: { padding: 14, paddingHorizontal: 22, borderTopWidth: 1, borderTopColor: colors.line, backgroundColor: colors.paper2, flexDirection: 'row', justifyContent: 'flex-end', gap: 10 },
});
